<app-windowlist [model]="this">
    <div class="card">
        <div class="row p-1">            
            <div class="col-md-8">
                <div class="input-group input-group-info input-group-sm p-1">
                    <app-selecttables [name]="'filter_customfields'" [value]="filter_customfields.value" [show_all]="true" (onchange)="filter_customfields.value=$event;getItems()"></app-selecttables>
                    <div class="input-group-append ">                        
                    </div>
                </div>
            </div>      
            <div class="col-md-4">                
                <button class="btn btn-primary btn-sm float-right m-1" title="aggiorna" type="submit" (click)="getItems()"><i class="fa fa-sync"></i></button>
                <button class="btn btn-success btn-sm float-right m-1" title="Aggiungi" data-toggle="modal" data-target="#modalOptionCustomField" (click)="addCustomField()"><i class="fa fa-plus mr-1"></i>Aggiungi</button>
            </div>
        </div>
        <form>
        <table class="table table-sm table-striped m-0" >
            <thead>
                <th>ID</th>
                <th>Etichetta</th>
                <th>Nome campo</th>
                <th class="text-center">Tabella</th>                
                <th class="text-center">Tipologia</th>                
                <th class="text-center">Ordine</th>
                <!-- <th class="text-center">Accesso</th> -->
                <th></th>
            </thead>
            <tbody>

                <!-- elemento ripetuto -->
                <tr *ngFor="let record of list" 
                    [class.font-weight-bold]="record.type=='separator'" 
                    [class.text-gray]="record.access==''" >
                    <td>                       
                        {{record.id}}
                    </td>
                    <td>
                        {{record.label}}
                    </td>
                    <td>                       
                        <small><i>{{record.name}}</i></small>
                    </td>
                    <td class="text-center">
                        <small><app-selecttables [value]="record.table" [no_select]="true"></app-selecttables></small>
                    </td>                 
                    <td  class="text-center">
                        <small>
                            <span *ngIf="record.type=='text'"        >Casella di Testo</span>
                            <span *ngIf="record.type=='textarea'"    >Area di Testo</span>
                            <span *ngIf="record.type=='number'"      >Numero</span>
                            <span *ngIf="record.type=='currency'"    >Valuta</span>
                            <span *ngIf="record.type=='date'"        >Data</span>
                            <span *ngIf="record.type=='time'"        >Orario</span>
                            <span *ngIf="record.type=='boolean'"     >Sì/No</span>
                            <span *ngIf="record.type=='select'"      >Casella di riepilogo</span>                        
                            <span *ngIf="record.type=='checkbox'"    >Casella di controllo</span>
                            <span *ngIf="record.type=='file'"        >File</span>
                            <span *ngIf="record.type=='photo'"       >Immagine</span>
                            <span *ngIf="record.type=='formula'"     >Formula</span>
                            <span *ngIf="record.type=='address'"     >Anagrafica</span>
                            <span *ngIf="record.type=='document'"    >Documento</span>
                            <span *ngIf="record.type=='table'"       >Tabella</span>
                            <span *ngIf="record.type=='separator'"   >Separatore</span>
                        </small>
                    </td>                  
                    <td class="">
                         <div class="input-group input-group-info input-group-sm justify-content-center m-auto" style="max-width: 6rem">
                            <input style="max-width: 4rem" type="number" class="form-control form-control-sm" placeholder="..." name="ordering[{{record.id}}]" [(ngModel)]="record.ordering" (keyup)="record['changed']=true">
                             <div class="input-group-append input-group-append-sm">
                                <button type="button" *ngIf="record['changed']!=undefined || record['changed']==false" title="Salva" class="btn btn-warning btn-sm" (click)="save(record);record['changed']=false;getItems()"><i class="fas fa-save"></i></button>
                                <button type="button" *ngIf="record['changed']!=undefined || record['changed']==false" title="Annulla" class="btn btn-sm" (click)="record['changed']=true"><i class="fas fa-times text-danger"></i></button>
                             </div>
                         </div>                        
                    </td>
                    <!-- <td class="text-center">
                        <span class="badge badge-success ml-2" *ngIf="record.access!='superuser,admin'">Pubblico</span>
                        <span class="badge badge border ml-2" *ngIf="record.access=='superuser,admin'">Privato</span>
                    </td> -->
                    <td class="pr-2">
                        <button  type="button" title="Elimina" class="btn btn-danger btn-xs float-right ml-1"  (click)="confirm_delete(record.id)"><i class="far fa-trash-alt"></i></button>
                        <button type="button" class="btn btn-danger btn-xs float-right ml-1"  (click)="resetAllValueCustomField(record.id)" title="Resetta tutti i valori"><i class="fa fa-times-circle"></i></button> 
                        <button type="button" title="Duplica" class="btn btn-info btn-xs float-right ml-1 " (click)="duplicate(record)"><i class="far fa-clone"></i></button>
                        <button type="button" class="btn btn-secondary btn-xs float-right ml-1"  (click)="openDetail(record,{'name':'table','value':record.table})"><i class="fas fa-pencil-alt"></i>&ensp;</button>
                </tr>
            </tbody>
        </table>
        </form>

        <div class="card-footer clearfix py-1">
            <app-pagination [model]="this" ></app-pagination>
        </div>
    </div>
</app-windowlist>

<div class="modal fade" id="modalOptionCustomField" tabindex="-1" role="dialog" >
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <b>Aggiungi campo</b>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-dismiss="modal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="modal-body" *ngIf="selectedCustomField">
                <div class="row">
                    <!-- <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Nome</label>
                            <input class="form-control form-control-sm" type="text" name="name" [(ngModel)]="selectedCustomField.name"/>
                        </div>
                    </div> -->
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Etichetta</label>
                            <input class="form-control form-control-sm" type="text" name="label" [(ngModel)]="selectedCustomField.label"/>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Tabella</label>
                            <app-selecttables [name]="'table'" [value]="selectedCustomField.table" [show_all]="false" (onchange)="selectedCustomField.table=$event;"></app-selecttables>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Tipologia</label>
                            <select name="type"  class="form-control form-control-sm" [(ngModel)]="selectedCustomField.type" (change)="changeType()">
                                <option value="text">Testo</option>
                                <option value="textarea">Area di testo</option>
                                <option value="number">Numero</option>
                                <option value="currency">Valuta</option>
                                <option value="date">Data</option>
                                <option value="time">Orario</option>
                                <option value="boolean">Sì/No</option>
                                <option value="select">Casella di riepilogo</option>
                                <option value="checkbox">Casella di controllo</option>
                                <option value="file">File</option>
                                <option value="photo">Immagine</option>
                                <option value="formula">Formula</option>
                                <option value="address">Anagrafica</option>
                                <option value="document">Documento</option>
                                <option value="table">Tabella</option>
                                <option value="separator">Separatore</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-success btn-block" data-dismiss="modal" (click)="confirmOptionField();getItems()"><i class="fas fa-plus mr-1"></i>Aggiungi</button>
                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal"  >Annulla</button> -->
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade" id="modalOptionCustomField" tabindex="-1" role="dialog" >
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <b>Dettaglio campo</b>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-dismiss="modal">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="modal-body" *ngIf="selectedCustomField">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Nome</label>
                            <input class="form-control form-control-sm" type="text" name="name" [(ngModel)]="selectedCustomField.name"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Etichetta</label>
                            <input class="form-control form-control-sm" type="text" name="label" [(ngModel)]="selectedCustomField.label"/>
                        </div>
                    </div>
                    
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Stato</label>
                            <select name="status" class="form-control form-control-sm" name="status" [(ngModel)]="selectedCustomField.status">
                                <option value="0">Non pubblicato</option>
                                <option value="1">Pubblicato</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Tabella</label>
                            <app-selecttables [name]="'table'" [value]="selectedCustomField.table" [show_all]="false" (onchange)="selectedCustomField.table=$event;"></app-selecttables>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Tipologia</label>
                                <select name="type"  class="form-control form-control-sm" [(ngModel)]="selectedCustomField.type" (change)="changeType()">
                                    <option value="text"        >Casella di Testo</option>
                                    <option value="textarea"    >Area di Testo</option>
                                    <option value="number"      >Numero</option>
                                    <option value="select"      >Elenco</option>
                                    <option value="date"        >Data</option>
                                    <option value="checkbox"    >Casella di controllo</option>
                                    <option value="currency"    >Valuta</option>
                                    <option value="url"         >URL</option>
                                    <option value="separator"   >Separatore</option>
                                    <option value="multi"       >Multivalore</option>
                                    <option value="tax_code"    >Codice Fiscale</option>
                                    <option value="image"       >Immagine</option>
                                    <option value="hidden"      >Nascosto</option>
                                    <option value="address"     >Anagrafica</option>
                                </select>
                            </div>
                    </div>
                    <div class="col-lg-12" *ngIf="selectedCustomField.type=='select' || selectedCustomField.type=='tax_code' || selectedCustomField.type=='address'" >
                        <div class="form-group form-group-sm">
                            <label>Opzioni
                                 <small>(aggiungere i valori e premere invio)</small>
                            </label>                            
                            <textarea class="form-control form-control-sm" *ngIf="selectedCustomField.type=='tax_code'" [(ngModel)]="selectedCustomField.option" name="option_field" ></textarea>
                            <ng-container *ngIf="selectedCustomField.type=='select'">
                                <textarea  class="form-control" [(ngModel)]="selectedCustomField.option" name="option_field"></textarea>
                                <small>
                                    STRUTTURA:<br>
                                    [&lbrace;"item":"Valore1"&rbrace;,&lbrace;"item":"Valore2"&rbrace;,...]
                                </small>
                            </ng-container>

                            <ng-container *ngIf="selectedCustomField.type=='address'">
                                <br/>
                                <label>Tipologia anagrafica di default</label>
                                <select class="form-control form-control-sm" [(ngModel)]="selectedCustomField.option" name="option_field">
                                    <option value="">Nessuno</option>
                                    <option *ngFor="let t of address_types" value='[{"name":"id_type","value":{{t.id}}}]'>{{t.name}}</option>
                                </select>

                               
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Condizione di visualizzazione</label>
                             <div class="input-group input-group-sm mb-1">                               
                                <input class="form-control form-control-sm" placeholder="indicare il valore ID..." name="condition_id" [(ngModel)]="selectedCustomField.condition_id"/>
                                <div class="input-group-append input-group-append-sm">
                                    <span class="input-group-text input-group-text-sm">ID</span>
                                </div>
                            </div>
                            <div class="input-group input-group-sm mb-0">                               
                                <input class="form-control form-control-sm" placeholder="indicare il campo di riferimento..." name="condition_field" [(ngModel)]="selectedCustomField.condition_field"/>
                                <div class="input-group-append input-group-append-sm">
                                    <span class="input-group-text input-group-text-sm">CAMPO</span>
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Al salvataggio replica valore nel campo ...</label>
                            <select class="form-control form-control-sm" name="replicate_to" [(ngModel)]="selectedCustomField.replicate_to">
                                <option value="0">Nessuno</option>
                                <option *ngFor="let c of customfieldsList" [ngValue]="c.id">{{c.label}} ({{c.table}})</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="form-group form-group-sm">
                            <label>Tag</label>
                            <input class="form-control form-control-sm" name="condition_tag" [(ngModel)]="selectedCustomField.tag"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Accesso</label>
                            <div class="input-group input-group-sm" >
                                <select name="status" class="form-control form-control-sm" name="access" [(ngModel)]="selectedCustomField.access">
                                    <option value="superuser,admin,manager,agent,guest">Pubblico</option>
                                    <option value="superuser,admin">Privato</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group form-group-sm">
                            <label>Mostra etichetta</label>
                            <select class="form-control form-control-sm" name="show_label" [(ngModel)]="selectedCustomField.show_label">
                                <option value="1">Si</option>
                                <option value="0">No</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal" (click)="confirmOptionField();getItems()"><i class="fas fa-save mr-1"></i> Conferma</button>
                <button type="button" class="btn btn-secondary" data-dismiss="modal"  >Annulla</button>
            </div>
        </div>
    </div>
</div> -->